"use client";

import cx from "classnames";
import { FC } from "react";
import Button from "../button";

interface IActionButton {
  caption: string;
  layoutType: "list" | "detail";
  VIN: string;
}

const LEGACY_CLASSNAME = "autofi_calculate_button_button_qwe";

const AutofiCalculatePaymentButton: FC<IActionButton> = ({ caption, layoutType, VIN }) => {
  const className = layoutType === "list" ? "autofi_calculate_button_list" : "autofi_calculate_button_detail";
  return (
    <Button className={cx(className, LEGACY_CLASSNAME)} data-vin={VIN}>
      {caption}
    </Button>
  );
};

export default AutofiCalculatePaymentButton;
